import { Route } from 'react-router-dom';

import { ExchangeRateDetailPage } from './pages/exchange-rate-detail-page.js';
import { ExchangeRateFormPage } from './pages/exchange-rate-form-page.js';
import { ExchangeRateListPage } from './pages/exchange-rate-list-page.js';

export function exchangeRateRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/exchange-rates" element={<ExchangeRateListPage />} />
      <Route path="/exchange-rates/new" element={<ExchangeRateFormPage />} />
      <Route path="/exchange-rates/:exchangeRateId/edit" element={<ExchangeRateFormPage />} />
      <Route path="/exchange-rates/:exchangeRateId" element={<ExchangeRateDetailPage />} />
    </>
  );
}
